import React from "react";
import { withNamespaces } from "react-i18next";

const X33GuidesLink = ({ t, className }) => (
  <a href={t("footer.x33-guides-url")} className={className}>
    {t("footer.x33-guides")}
  </a>
);

export default withNamespaces("translation")(X33GuidesLink);
